import { Pipe, PipeTransform } from '@angular/core';
import { Learning_Type } from '@app/enums/learning-type.enum';

@Pipe({
  name: 'instructionTypeCustomButton',
  standalone: false,
})
export class InstructionTypeCustomButtonPipe implements PipeTransform {
  /**
   * Return transformed Learning Type string for footer button styling to show.
   * @param learningType - instruction type (learning type) to transform to new display type else empty string, if not shown.
   * @returns - transformed instruction (learning type) css name string for footer button styling.
   */
  public transform(learningType: string): string {
    switch (learningType) {
      case Learning_Type.E_LEARNING:
      case Learning_Type.QUICK_LEARNING:
      case Learning_Type.WEBINAR:
        return 'btn-inverse-elearning';
      case Learning_Type.CERTIFICATION_EXAM:
        return 'btn-inverse-certificate-exam';
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.VIRTUAL:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.SELF_STUDY:
      case Learning_Type.WORKSHOP:
        return 'btn-inverse-course';
      default:
        return '';
    }
  }
}
